"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldValidationWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var react_html_parser_1 = require("react-html-parser");
var journey_services_1 = require("@athena-portal/journey-services");
var services_1 = require("@falcon/services");
var FieldValidationWidget = /** @class */ (function (_super) {
    __extends(FieldValidationWidget, _super);
    function FieldValidationWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            showErrorMessage: true
        };
        _this.handleClose = _this.handleClose.bind(_this);
        return _this;
    }
    FieldValidationWidget.prototype.render = function () {
        var bottomText = this.renderHtml(this.getSetting("bottomText")) || "Please try again.";
        if (this.state.showErrorMessage) {
            return ((0, jsx_runtime_1.jsxs)("div", { className: "page-validation journey-validation-summary", role: "alert", children: [(0, jsx_runtime_1.jsx)("div", { className: "page-validation-alert", children: (0, jsx_runtime_1.jsx)("img", { className: "page-validation-alert-icon", alt: "Alert icon", src: "/".concat(services_1.resourcesHelper.THEME, "/img/alert-red.svg") }) }), (0, jsx_runtime_1.jsxs)("div", { className: "page-validation-message", children: [(0, jsx_runtime_1.jsx)("p", { className: "page-validation-message-top", children: this.getSetting("topText") }), (0, jsx_runtime_1.jsx)("p", { className: "page-validation-message-bottom", children: bottomText })] }), (0, jsx_runtime_1.jsx)("div", { className: "page-validation-close", children: (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn page-validation-close-button", "aria-label": "close alert", onClick: this.handleClose }) })] }));
        }
        else {
            return null;
        }
    };
    FieldValidationWidget.prototype.renderHtml = function (htmlText) {
        return (0, react_html_parser_1.default)(this.renderTemplate(htmlText, true), {
            transform: function (node) {
                if (node.name === 'script' || node.name === 'style' || node.name === 'link') {
                    return null;
                }
                return;
            }
        });
    };
    FieldValidationWidget.prototype.renderTemplate = function (template, escapeFields) {
        return journey_services_1.ExpressionEvaluator.renderTemplate(template, this.props.interaction, escapeFields);
    };
    FieldValidationWidget.prototype.handleClose = function () {
        this.setState({
            showErrorMessage: false
        });
    };
    return FieldValidationWidget;
}(plugin_journey_1.WidgetBase));
exports.FieldValidationWidget = FieldValidationWidget;
//# sourceMappingURL=FieldValidationWidget.js.map